module.exports = __webpack_public_path__ + "static/img/game-logo.323af81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-firehero/tw/h5/imgs/game-logo.png
// module id = HADW
// module chunks = 13